import { matchPath } from 'react-router-dom';
import PATHS from '../../routes/routes.const';

const CONTRACT_SIGN_PATHS = [
  PATHS.main.orders.contract.sign.ptBR.path,
  PATHS.main.orders.contract.sign.enUS.path,
];

export const isContractSignPath = ({ pathname }: { pathname: string }) =>
  CONTRACT_SIGN_PATHS.some((path) => !!matchPath(pathname, path)?.isExact);
